import axios from "axios";

const BASE = process.env.REACT_APP_API_BASE_URL || "http://localhost:5051";

const api = axios.create({ baseURL: BASE });

// Always inject fresh token before requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
